import { createAuthClient } from 'better-auth/react';

/**
 * Matches `basePath` in apps/api/src/auth.ts. Left relative so the same bundle
 * works on localhost, every preview host and production.
 */
export const authClient = createAuthClient({
  basePath: '/api/auth',
});

export const { signIn, signUp, signOut, useSession } = authClient;
